// extracted by mini-css-extract-plugin
export var sliderRange = "_nt-2";
export var sliderRoot = "_nt-0";
export var sliderThumb = "_nt-3";
export var sliderTrack = "_nt-1";